var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"allowClear":true,"placeholder":_vm.placeholder,"value":_vm.selectedEditionIndex},on:{"change":function($event){return _vm.selectChange($event)}}},_vm._l((_vm.editions),function(item,index){return _c('a-select-option',{key:index,attrs:{"value":index}},[_vm._v(_vm._s(item.displayText))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }